import { Component, Input, OnInit } from '@angular/core';
import {
  FormGroup,
  FormGroupDirective,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { NzInputDirective } from 'ng-zorro-antd/input';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-form-input',
  standalone: true,
  imports: [FormsModule, NzInputDirective, ReactiveFormsModule, NgClass],
  templateUrl: './form-input.component.html',
  styleUrl: './form-input.component.scss',
  host: {
    class: 'grid grid-cols-12',
  },
})
export class FormInputComponent implements OnInit {
  @Input({ required: true }) label!: string;
  @Input({ required: true }) attribute!: string;
  @Input() readOnly = false;
  @Input() subformGroup: string | null = null;
  form!: FormGroup;
  currentForm!: FormGroup;

  constructor(private rootFormGroup: FormGroupDirective) {}

  ngOnInit() {
    this.form = this.rootFormGroup.control;

    if (this.subformGroup) {
      const group = this.form.get(this.subformGroup) as FormGroup;
      if (!group) {
        throw new Error(
          `SubFormGroup "${this.subformGroup}" does not exist in form`,
        );
      }
      this.currentForm = group;
    } else {
      this.currentForm = this.form;
    }
  }
}
